/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import * as commons from './commons';
import './boxForRecord.css';

import { API_PATH, CONV_STR, TRANS_STR, LIMIT_DEFO } from './constant/constant';
import Footer from './components/Footer';
// アイコンのimport
import jAlertIcon from './images/icon/J-alert.svg';
import lAlertIcon from './images/icon/L-alert.svg';
import megaphoneIcon from './images/icon/megaphone.svg';
import machiupIcon from './images/icon/machiup.svg';
import googleIconTrans from './images/icon/GoogleAttrTrans.png';
import googleIconTransWhite from './images/icon/GoogleAttrTransWhite.png';

// クラス名
class List extends Component {
  constructor(props) {
    super(props);
    // 初期状態
    this.state = {
      tableHead: [],
      scrollPosition: 0,
      pageNum: 1,
      listMobile: [],
      listPc: [],
      dataNum: 0,
      sort: -1,
      bottom: 0,
      scrollValue: 0,
      lgName: '',
      transType: '2',
      convType: '2',
      transTypeArrMobile: [],
      transTypeArrPc: [],
      convTypeArrMobile: [],
      convTypeArrPc: [],
      period: {},
      title: '',
      topPageMobile: 1,
      bottomPageMobile: 1,
      topPagePc: 1,
      bottomPagePc: 1,
      displayData: [],
      tag: 0,
      filename: '',
      limit: 0,
      passNameMobile: [],
      passNamePc: [],
      listPcHeader: [],
      width: 0,
      browser: '',
    };
  }

  // 画面遷移時に以下の内容を実行してくれる。
  componentDidMount = async () => {
    document.title = '音声一覧画面';
    const lgCd = this.getLclGov();
    const master = await commons.getAudioSet(lgCd);

    if (master === false) {
      window.alert('データの取得に失敗しました。');
      return;
    }

    const { title = '', expiry_days: expiryDays = '' } = master;
    const { display = { disp_conv: '2', disp_trans: '2' } } = master;
    const { disp_conv = '2', disp_trans = '2' } = display;
    const limit = LIMIT_DEFO;
    const width = window.innerWidth;
    const userAgent = window.navigator.userAgent.toLowerCase();
    let browser = '';
    if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) {
      browser = 'IE';
      this.setState({ browser });
    }
    this.setState({ title, transType: disp_trans, convType: disp_conv, limit, width });
    const data2 = await this.getDisplayData(lgCd, expiryDays);
    if (data2 === false) {
      return;
    }
    this.createBody();
    const elementHTML = document.documentElement;
    const top = elementHTML.clientHeight - elementHTML.scrollHeight;
    setTimeout(() => {
      // スクロールの位置が0で発火
      if (top >= 0) {
        // const lgCd = this.getLclGov();
        // this.getAddData(lgCd);
        this.createBody();
      }
    }, 200);
    // スクロールの位置を取得に使用
    if (browser === 'IE') {
      const tableBody = document.getElementById('tbody-ie');
      tableBody.addEventListener('scroll', this.watchScrollPositionList, true);
      window.addEventListener('scroll', this.watchScrollPositionList, true);
    } else {
      window.addEventListener('scroll', this.watchScrollPositionList, true);
    }
    const { topPageMobile, bottomPageMobile, topPagePc, bottomPagePc } = this.state;
    const { location } = this.props;
    const { state = { path: '' } } = location;
    const { path: filename = '' } = state;
    if (filename !== '') {
      this.setState({ filename });
      this.search(filename);
      const data = await this.createBody();
      if (data) {
        if (width < 769) {
          if (topPageMobile === bottomPageMobile) {
            this.jumpToDestination();
          }
        } else {
          if (topPagePc === bottomPagePc) {
            this.jumpToDestinationPc();
          }
        }
        return;
      }
    } else {
      const data = await this.createBody();
      if (data) {
        if (
          topPageMobile === 1 &&
          bottomPageMobile === 1 &&
          topPagePc === 1 &&
          bottomPagePc === 1 //||
          // filename !== ''
        ) {
          // const windowWidth = window.innerWidth;
          if (width < 769) {
            const bottom = elementHTML.scrollHeight - elementHTML.clientHeight;
            window.scrollTo(0, bottom);
            // window.scrollTo(0, 9999);
          } else {
            window.scrollTo(0, 0);
          }
        }
      }
      return;
    }
  };

  // スクロールの位置を取得に使用
  watchScrollPositionList = () => {
    const currentPosition = this.scrollTop();
    const { displayData, limit, browser } = this.state;
    let { topPageMobile, bottomPageMobile, topPagePc, bottomPagePc } = this.state;
    const dataNum = displayData.length;
    let maxPage = 0;
    if (browser === 'IE') {
      const tableCurrentPosition = this.tableScrollTop();
      const tableBody = document.getElementById('tbody-ie');
      const tableScrollHeight = tableBody.scrollHeight;
      const tableClientHeight = tableBody.clientHeight;
      const tablebottom = tableScrollHeight - tableClientHeight;

      if (dataNum % limit === 0) {
        maxPage = dataNum / limit;
      } else {
        maxPage = Math.ceil(dataNum / limit);
      }
      const elementHTML = document.documentElement;
      const bottom = elementHTML.scrollHeight - elementHTML.clientHeight;

      // 追記
      const windowWidth = window.innerWidth;

      if (windowWidth >= 769) {
        if (!(topPagePc === 1 && bottomPagePc === maxPage)) {
          setTimeout(async () => {
            if (tableCurrentPosition === tablebottom) {
              if (bottomPagePc < maxPage) {
                topPageMobile += 1;
                bottomPagePc += 1;
                this.setState({ bottomPagePc, topPageMobile });
                const waitMobile = await this.addPassNameMobile();
                const waitPc = await this.addPassNamePc();
                if (waitMobile && waitPc) {
                  const data = await this.createBody();
                  if (data) {
                    if (bottomPagePc === 1 && topPagePc === 1) {
                      tableBody.scrollTo(0, 0);
                    } else {
                      // tableBody.scrollTo(0, tableCurrentPosition);
                      // window.scrollTo(0, elementHTML.scrollTop);
                    }
                  }
                }
              }
            }
          }, 300);
        }
      } else {
        if (!(bottomPageMobile === 1 && topPageMobile === maxPage)) {
          setTimeout(async () => {
            if (currentPosition === 0) {
              if (topPageMobile < maxPage) {
                topPageMobile += 1;
                bottomPagePc += 1;
                this.setState({ topPageMobile, bottomPagePc });
                const waitMobile = await this.addPassNameMobile();
                const waitPc = await this.addPassNamePc();
                if (waitMobile && waitPc) {
                  const data = await this.createBody();
                  if (data) {
                    if (bottomPageMobile === 1 && topPageMobile === 1) {
                      window.scrollTo(0, elementHTML.scrollHeight);
                    } else if (topPageMobile <= maxPage || bottomPageMobile !== 1) {
                      window.location.hash = `chatbox${(topPageMobile - 1) * limit}`;
                    }
                  }
                }
              }
            } else if (bottom - currentPosition < 15) {
              if (bottomPageMobile > 1) {
                bottomPageMobile -= 1;
                topPagePc -= 1;
                this.setState({ bottomPageMobile });
                const waitMobile = await this.addPassNameMobile();
                const waitPc = await this.addPassNamePc();
                if (waitMobile && waitPc) {
                  const data = await this.createBody();
                  if (data) {
                    if (bottomPageMobile === 1 && topPageMobile === 1) {
                      window.scrollTo(0, elementHTML.scrollHeight);
                    } else {
                      window.scrollTo(0, currentPosition);
                      // window.scrollTo(0, elementHTML.scrollTop);
                    }
                  }
                }
              }
            }
          }, 300);
        }
      }
    } else {
      if (dataNum % limit === 0) {
        if (dataNum === 0) {
          maxPage = 1;
        } else {
          maxPage = dataNum / limit;
        }
      } else {
        maxPage = Math.ceil(dataNum / limit);
      }
      const elementHTML = document.documentElement;
      const bottom = elementHTML.scrollHeight - elementHTML.clientHeight;

      // 追記
      const windowWidth = window.innerWidth;

      if (windowWidth >= 769) {
        if (!(topPagePc === 1 && bottomPagePc === maxPage)) {
          setTimeout(async () => {
            if (bottom - currentPosition < 15) {
              if (bottomPagePc < maxPage) {
                topPageMobile += 1;
                bottomPagePc += 1;
                this.setState({ bottomPagePc, topPageMobile });
                const waitMobile = await this.addPassNameMobile();
                const waitPc = await this.addPassNamePc();
                if (waitMobile && waitPc) {
                  const data = await this.createBody();
                  if (data) {
                    if (bottomPagePc === 1 && topPagePc === 1) {
                      window.scrollTo(0, 0);
                    } else {
                      window.scrollTo(0, currentPosition);
                    }
                  }
                }
              }
            }
          }, 300);
        }
      } else {
        if (!(bottomPageMobile === 1 && topPageMobile === maxPage)) {
          setTimeout(async () => {
            // スクロールの位置が0で発火
            if (currentPosition === 0) {
              if (topPageMobile < maxPage) {
                topPageMobile += 1;
                bottomPagePc += 1;
                this.setState({ topPageMobile, bottomPagePc });
                const waitMobile = await this.addPassNameMobile();
                const waitPc = await this.addPassNamePc();
                if (waitMobile && waitPc) {
                  const data = await this.createBody();
                  if (data) {
                    if (bottomPageMobile === 1 && topPageMobile === 1) {
                      window.scrollTo(0, elementHTML.scrollHeight);
                    } else if (topPageMobile <= maxPage || bottomPageMobile !== 1) {
                      window.location.hash = `chatbox${(topPageMobile - 1) * limit}`;
                    }
                  }
                }
              }
            } else if (bottom - currentPosition < 15) {
              if (bottomPageMobile > 1) {
                bottomPageMobile -= 1;
                topPagePc -= 1;
                this.setState({ bottomPageMobile });
                const waitMobile = await this.addPassNameMobile();
                const waitPc = await this.addPassNamePc();
                if (waitMobile && waitPc) {
                  const data = await this.createBody();
                  if (data) {
                    if (bottomPageMobile === 1 && topPageMobile === 1) {
                      window.scrollTo(0, elementHTML.scrollHeight);
                    } else {
                      window.scrollTo(0, currentPosition);
                    }
                  }
                }
              }
            }
          }, 300);
        }
      }
    }
  };

  // 垂直方向のスクロール量を取得
  scrollTop = () => {
    return Math.max(
      window.pageYOffset,
      document.documentElement.scrollTop,
      document.body.scrollTop
    );
  };

  tableScrollTop = () => {
    const tableBody = document.getElementById('tbody-ie');
    return tableBody.scrollTop;
  };

  // 市町村コードの取得
  getLclGov = () => {
    var url = this.props.location.pathname;
    const num = url.lastIndexOf('/');
    const path = url.slice(num + 1);
    this.setState({
      lgCd: path,
    });
    // TODO:永続化するならこのタイミング
    return path;
  };

  // 表示データの取得
  getDisplayData = async (lgCd, expiryDays) => {
    const { sort } = this.state;
    const data = await axios
      .post(`${API_PATH}/v/getDisplayData`, { lgCd, sort, expiryDays })
      .then(async (res) => {
        const displayData = [];
        for (let i = 0; i < res.data.length; i++) {
          displayData.push(res.data[i]);
        }
        // 自治体マスタから市町村名を取得するように修正 2020/09/14
        // const lgName = displayData[0].lcl_gov.lg_name;
        const lgName = await commons.getLgName(lgCd);
        this.setState({ displayData, lgName });
        return true;
      })
      .catch((err) => {
        window.alert('データの取得に失敗しました。');
        return false;
      });
    return data;
  };

  // 表示データの追加分の作成
  addPassNameMobile = async () => {
    const { passNameMobile, displayData, topPageMobile, bottomPageMobile, limit } = this.state;
    let limitNum = topPageMobile * limit;
    if (limitNum > displayData.length) {
      limitNum = displayData.length;
    }
    const skip = (bottomPageMobile - 1) * limit;
    passNameMobile.length = 0;
    if (displayData.length > passNameMobile.length) {
      passNameMobile.length = 0;
      for (let i = skip; i < limitNum; i += 1) {
        passNameMobile.push(displayData[i]);
      }
      this.setState({ passNameMobile });
    }
    return true;
  };

  // 追記
  addPassNamePc = async () => {
    const { passNamePc, displayData, bottomPagePc, limit } = this.state;
    let limitNum = bottomPagePc * limit;
    if (limitNum > displayData.length) {
      limitNum = displayData.length;
    }
    passNamePc.length = 0;
    if (displayData.length > passNamePc.length) {
      passNamePc.length = 0;
      // for (let i = skip; i < limit; i += 1) { // 特定のdivより新しいものをすべて表示　2020/10/02
      for (let i = 0; i < limitNum; i += 1) {
        passNamePc.push(displayData[i]);
      }
      this.setState({ passNamePc });
    } else {
      return true;
    }
    return true;
  };

  search = (filename) => {
    const { displayData, limit } = this.state;
    const windowWidth = window.innerWidth;
    let maxPage = 0;
    const dataNum = displayData.length;
    if (dataNum % limit === 0) {
      if (dataNum === 0) {
        maxPage = 1;
      } else {
        maxPage = dataNum / limit;
      }
    } else {
      maxPage = Math.ceil(dataNum / limit);
    }
    for (let i = 0; i < displayData.length; i++) {
      const { send_contents: sendContents = { filename: '' } } = displayData[i]; // 2020/09/30
      const { filename: filenameData = '' } = sendContents; // 2020/09/30
      // if (filename === displayData[i].recv_contents.filename) { 2020/09/03
      if (filename === filenameData) {
        if (windowWidth < 769) {
          if (i % limit === 0) {
            const num = i / limit + 1;
            if (num > 1) {
              this.setState({
                pageNum: num,
                topPageMobile: num,
                bottomPageMobile: num - 1,
                topPagePc: num - 1,
                bottomPagePc: num,
                tag: i,
              });
            } else {
              this.setState({
                pageNum: num,
                topPageMobile: num + 1,
                bottomPageMobile: num,
                topPagePc: num,
                bottomPagePc: num + 1,
                tag: i,
              });
            }
          } else {
            const num = Math.ceil(i / limit);
            if (num > 1) {
              this.setState({
                pageNum: num,
                topPageMobile: num,
                bottomPageMobile: num - 1,
                topPagePc: num - 1,
                bottomPagePc: num,
                tag: i,
              });
            } else {
              this.setState({
                pageNum: num,
                topPageMobile: num + 1,
                bottomPageMobile: num,
                topPagePc: num + 1,
                bottomPagePc: num,
                tag: i,
              });
            }
          }
        } else {
          if (i % limit === 0) {
            const num = i / limit + 1;
            if (num === maxPage) {
              this.setState({
                pageNum: num,
                topPagePc: num,
                bottomPagePc: num,
                topPageMobile: num,
                bottomPageMobile: num,
                tag: i,
              });
            } else {
              this.setState({
                pageNum: num,
                topPagePc: num,
                bottomPagePc: num + 1,
                topPageMobile: num + 1,
                bottomPageMobile: num,
                tag: i,
              });
            }
          } else {
            const num = Math.ceil(i / limit);
            if (num === maxPage) {
              this.setState({
                pageNum: num,
                topPagePc: num,
                bottomPagePc: num,
                topPageMobile: num,
                bottomPageMobile: num,
                tag: i,
              });
            } else {
              this.setState({
                pageNum: num,
                topPagePc: num,
                bottomPagePc: num + 1,
                topPageMobile: num + 1,
                bottomPageMobile: num,
                tag: i,
              });
            }
          }
        }
        return;
      }
    }
  };

  jumpToDestination = () => {
    const { tag } = this.state;
    const elementHTML = document.documentElement;
    const bottom = elementHTML.scrollHeight - elementHTML.clientHeight;
    if (tag === 0) {
      window.scrollTo(0, bottom);
      const target = document.getElementById(`chatbox${tag}`);
      target.classList.add('box-active');
    } else {
      const target = document.getElementById(`chatbox${tag}`);
      window.location.hash = `chatbox${tag}`;
      target.classList.add('box-active');
    }
  };

  jumpToDestinationPc = () => {
    const { tag, displayData } = this.state;
    const dataNum = displayData.length - 1;
    if (tag === 0) {
      window.scrollTo(0, 0);
      const target = document.getElementById(`listBoxTr${tag}`);
      target.classList.add('box-active');
    } else if (tag === dataNum) {
      const target = document.getElementById(`listBoxTr${tag}`);
      window.location.hash = `listBoxTr${tag}`;
      target.classList.add('box-active');
    } else {
      const target = document.getElementById(`listBoxTr${tag}`);
      window.location.hash = `listBoxTr${tag}`;
      const currentPosition = this.scrollTop();
      window.scrollTo(0, currentPosition - 90);
      target.classList.add('box-active');
    }
  };

  handleToPlayerPage = (tmpUrl) => {
    window.removeEventListener('scroll', this.watchScrollPositionList, true);
    const { history } = this.props;
    const { lgCd } = this.state;
    const pageType = 'blist';

    // 末尾から4文字を取得
    const str = tmpUrl.slice(-4);
    let url = tmpUrl;
    if (str === '.mp3' || str === '.wav') {
      // 末尾から4文字を削除
      url = tmpUrl.slice(0, -4);
    }

    history.push({
      pathname: `/aplay/${lgCd}/${url}`,
      state: { pageType },
    });
  };

  /**
   * テキスト変換、翻訳の表示切替え(モバイル)
   * @param {int} i
   */
  changeConvType = async (i) => {
    let { convTypeArrMobile } = this.state;
    convTypeArrMobile[i] === '1' ? (convTypeArrMobile[i] = '2') : (convTypeArrMobile[i] = '1');
    this.setState({ convTypeArrMobile });
    this.createBody();
  };
  changeTransType = async (i) => {
    let { transTypeArrMobile } = this.state;
    transTypeArrMobile[i] === '1' ? (transTypeArrMobile[i] = '2') : (transTypeArrMobile[i] = '1');
    this.setState({ transTypeArrMobile });
    this.createBody();
  };
  /**
   * テキスト変換、翻訳の表示切替え(PC)
   * @param {int} i
   */
  changeConvTypePc = async (i) => {
    let { convTypeArrPc } = this.state;
    convTypeArrPc[i] === '1' ? (convTypeArrPc[i] = '2') : (convTypeArrPc[i] = '1');
    this.setState({ convTypeArrPc });
    this.createBody();
  };
  changeTransTypePc = async (i) => {
    let { transTypeArrPc } = this.state;
    transTypeArrPc[i] === '1' ? (transTypeArrPc[i] = '2') : (transTypeArrPc[i] = '1');
    this.setState({ transTypeArrPc });
    this.createBody();
  };

  createBody = async () => {
    const {
      passNameMobile,
      passNamePc,
      listMobile,
      listPc,
      bottomPageMobile,
      topPageMobile,
      bottomPagePc,
      topPagePc,
      convType,
      transType,
      limit,
      listPcHeader,
      filename,
      browser,
    } = this.state;
    let { convTypeArrMobile, transTypeArrMobile, convTypeArrPc, transTypeArrPc } = this.state;
    //以下追記

    if (filename !== '' || (topPageMobile === bottomPageMobile && topPagePc === bottomPagePc)) {
      await this.addPassNameMobile();
      await this.addPassNamePc();
    }

    // constで宣言しても配列を初期化できる
    // svgをimportする形に修正 2020/09/29
    // const imgTag = {
    //   防災卓: 'icon/megaphone.svg',
    //   Jアラート: 'icon/J-alert.svg',
    //   Lアラート: 'icon/L-alert.svg',
    // };

    /**
     * スマホ・タブレットに表示するアイコンを取得する
     * @param {string} mediaType メディアタイプ
     * @returns svgデータ
     */
    const getImgTag = (mediaType = '') => {
      if (mediaType === '防災卓') {
        return megaphoneIcon;
      } else if (mediaType === 'Jアラート') {
        return jAlertIcon;
      } else if (mediaType === 'Lアラート') {
        return lAlertIcon;
      } else if (mediaType === '') {
        // 受信データコピーしたときなど、紐づく受信データがないとき
        return machiupIcon;
      }

      return megaphoneIcon;
    };

    /**
     * PCサイズ一覧に表示する配信元を取得する
     * @param {string} mediaType
     * @returns spanタグ
     */
    const getTableImgTag = (mediaType = '') => {
      let mediaTypeClass = 'bg-other-type';
      let displayType = mediaType;

      if (mediaType === '防災卓') {
        mediaTypeClass = 'bg-bosai-taku';
      } else if (mediaType === 'Jアラート') {
        mediaTypeClass = 'bg-j-alert';
      } else if (mediaType === 'Lアラート') {
        mediaTypeClass = 'bg-l-alert';
      } else if (mediaType === 'メディアサーバ') {
        mediaTypeClass = 'bg-media-server';
      } else if (mediaType === '') {
        // 受信データコピーしたときなど、紐づく受信データがないとき
        displayType = 'まちあっぷ！';
        mediaTypeClass = 'bg-machiup';
      } else {
        displayType = 'その他';
      }

      return <span className={`badge ${mediaTypeClass}`}>{displayType}</span>;
    };

    listMobile.length = 0;
    listPcHeader.length = 0;
    listPc.length = 0;

    const disableFlag = convType === '0' && transType === '0';

    // データが0件の場合ヘッダをpushしない
    if (passNameMobile.length === 0 || passNamePc.length === 0) return;
    listPcHeader.push(
      <thead className={browser === 'IE' ? 'thead-ie' : null}>
        <tr className="list-header" key="list-header">
          <th className={browser === 'IE' ? 'head-title-ie' : null}>タイトル</th>
          <th className={browser === 'IE' ? 'head-date-ie' : null}>日時</th>
          <th className={browser === 'IE' ? 'head-media-ie' : null}>配信元</th>
          <th className={browser === 'IE' ? 'head-main-ie' : null}>内容</th>
          <th className={browser === 'IE' ? 'head-button-ie' : null}>再生</th>
          {disableFlag === true ? null : (
            <th className={browser === 'IE' ? 'head-detail-ie' : null}>音声文字変換 ・ 翻訳</th>
          )}
        </tr>
      </thead>
    );

    let date = 'yyyy/mm/dd';
    for (let i = passNameMobile.length - 1; i >= 0; i--) {
      // データを受信から配信データに変更 2020/09/03
      const {
        recv_comm: recvComm = { target_media_type: '' },
        send_contents: sendContents = {
          main: '',
          trans_voice: { voice_ja: '', voice_en: '' },
          title: '',
          filename: '',
        },
        rel_info: relInfo = { rel_st: '' },
        created_at: createdAt = '',
      } = passNameMobile[i];

      const { target_media_type: targetMediaType = '' } = recvComm;

      const { main = '' } = sendContents;
      const splitedMain = main.split('\n');
      const shapedMain = [];

      if (transTypeArrMobile.length < passNameMobile.length) {
        for (let i = passNameMobile.length - 1; i >= 0; i--) {
          transTypeArrMobile[i] = transType;
          convTypeArrMobile[i] = convType;
        }
      }
      for (let j = 0; j < splitedMain.length; j++) {
        if (splitedMain[j] === '') {
        } else {
          shapedMain.push(
            <div className="shapedMain" key={j}>
              {splitedMain[j]}
            </div>
          );
        }
      }

      const { rel_st: relSt = '' } = relInfo;

      const showingDate = relSt === '' ? createdAt : relSt;

      const customDate = commons.changeJapanDate(showingDate, 'YYYY年MM月DD日 (d)');
      if (date !== customDate) {
        // 日付区切り用のエレメント
        // const customDate = commons.changeJapanDate(aaa).substr(0, 15);
        listMobile.push(
          <div className="dateBox" key={`dataBox${i}`}>
            <div className="date" key={`date${i}`}>
              {customDate}
            </div>
          </div>
        );
        date = customDate;
      }
      const { trans_voice: transVoice = '', title = '', filename = '' } = sendContents; // 2020/09/30
      const { voice_ja = '', voice_en = '' } = transVoice;

      listMobile.push(
        <div
          className="chatbox"
          id={`chatbox${(bottomPageMobile - 1) * limit + i}`}
          key={`chatBox${i}`}
        >
          {/* 配信した時刻 */}
          <div className="iconBox">
            <img src={getImgTag(targetMediaType)} alt="Media Icon" />
            <p className="createdTime">{commons.changeJapanDate(showingDate).substr(16, 5)}</p>
          </div>
          <div className={i % 2 === 1 ? 'boxForRecordOdd' : 'boxForRecordEven'}>
            <div className="sendDetail">
              <div className="contentTitle">{title}</div>
              {shapedMain}
            </div>
            <div className="audioLink">
              <a
                className={i % 2 === 1 ? 'linkOdd' : 'linkEven'}
                onClick={() => this.handleToPlayerPage(filename, i)}
                data-tip={commons.changeJapanDate(showingDate)}
                style={{ width: '100%' }}
              >
                再生
              </a>
            </div>
          </div>
          {convType === '2' ? (
            convTypeArrMobile[i] === '2' ? (
              voice_ja !== '' ? (
                <div className="link-box">
                  <a
                    href=""
                    onClick={(e) => {
                      e.preventDefault();
                      this.changeConvType(i);
                    }}
                    className="trans-link-open"
                  >
                    {CONV_STR}
                  </a>
                </div>
              ) : null
            ) : voice_ja !== '' ? (
              <div className={i % 2 === 1 ? 'boxForRecordOdd-trans' : 'boxForRecordEven-trans'}>
                {voice_ja}
                <a
                  href=""
                  onClick={(e) => {
                    e.preventDefault();
                    this.changeConvType(i);
                  }}
                  className={i % 2 === 1 ? 'trans-link-close-odd' : 'trans-link-close-even'}
                >
                  {`[ 閉じる ]`}
                </a>
              </div>
            ) : null
          ) : convType === '1' ? (
            voice_ja !== '' ? (
              <div className={i % 2 === 1 ? 'boxForRecordOdd-trans' : 'boxForRecordEven-trans'}>
                {voice_ja}
              </div>
            ) : null
          ) : null}
          {transType === '2' ? (
            transTypeArrMobile[i] === '2' ? (
              voice_en !== '' ? (
                <div className="link-box">
                  <a
                    href=""
                    onClick={(e) => {
                      e.preventDefault();
                      this.changeTransType(i);
                    }}
                    className="trans-link-open"
                  >
                    {TRANS_STR}
                  </a>
                </div>
              ) : null
            ) : voice_en !== '' ? (
              <div>
                <div className={i % 2 === 1 ? 'boxForRecordOdd-trans' : 'boxForRecordEven-trans'}>
                  {/* <p>{voice_en}</p> */}
                  {voice_en}
                  <br />
                  <img
                    src={i % 2 === 1 ? googleIconTransWhite : googleIconTrans}
                    alt="translated by Google"
                    className="google-attribution"
                  />
                  <br />
                  <a
                    href=""
                    onClick={(e) => {
                      e.preventDefault();
                      this.changeTransType(i);
                    }}
                    className={i % 2 === 1 ? 'trans-link-close-odd' : 'trans-link-close-even'}
                  >
                    {`[ CLOSE ]`}
                  </a>
                </div>
              </div>
            ) : null
          ) : transType === '1' ? (
            voice_en !== '' ? (
              <div className={i % 2 === 1 ? 'boxForRecordOdd-trans' : 'boxForRecordEven-trans'}>
                {voice_en}
                <br />
                <img
                  src={i % 2 === 1 ? googleIconTransWhite : googleIconTrans}
                  alt="translated by Google"
                  className="google-attribution"
                />
              </div>
            ) : null
          ) : null}
        </div>
      );
    }

    // PC幅の表示データ生成
    for (let i = 0; i < passNamePc.length; i++) {
      const {
        recv_comm: recvComm = { target_media_type: '' },
        send_contents: sendContents = {
          main: '',
          trans_voice: { voice_ja: '', voice_en: '' },
          title: '',
          filename: '',
        },
        rel_info: relInfo = {
          rel_st: '',
        },
        created_at: createdAt = '',
      } = passNamePc[i];

      const { target_media_type: targetMediaType = '' } = recvComm;
      const { rel_st: relSt = '' } = relInfo;

      // rel_stがあればrelSt,なければcreateAt
      const showingDate = relSt === '' ? createdAt : relSt;

      const date = commons.changeJapanDate(showingDate, 'YYYY年MM月DD日 (d) hh:mm'); // .substr(0, 21);
      const { main = '' } = sendContents;
      const splitedMain = main.split('\n');
      const shapedMain = [];
      for (let j = 0; j < splitedMain.length; j++) {
        if (splitedMain[j] === '') {
        } else {
          shapedMain.push(
            <div className="shapedMain" key={j}>
              {splitedMain[j]}
            </div>
          );
        }
      }

      if (convTypeArrPc.length < passNamePc.length) {
        convTypeArrPc.push(convType);
      }
      if (transTypeArrPc.length < passNamePc.length) {
        transTypeArrPc.push(transType);
      }
      const {
        trans_voice: transVoice = { voice_ja: '', voice_en: '' },
        title = '',
        filename = '',
      } = sendContents;
      const { voice_ja: voiceJa = '', voice_en: voiceEn = '' } = transVoice;
      listPc.push(
        <tr
          className={i % 2 === 1 ? 'list-row-odd' : 'list-row-even'}
          key={`list-row${i}`}
          id={`listBoxTr${i}`}
        >
          <td className={browser === 'IE' ? 'column-title-ie' : 'column-title'}>{title}</td>
          <td className={browser === 'IE' ? 'column-date-ie' : 'column-date'}>{date}</td>
          <td className={browser === 'IE' ? 'column-media-ie' : 'column-media'}>
            {getTableImgTag(targetMediaType)}
          </td>
          <td className={browser === 'IE' ? 'column-main-ie' : 'column-main'}>{shapedMain}</td>
          <td className={browser === 'IE' ? 'column-button-ie' : 'column-button'}>
            <a
              className="linkEven"
              onClick={() => this.handleToPlayerPage(filename)}
              // data-tip={commons.changeJapanDate(createdAt)}
              data-tip={commons.changeJapanDate(showingDate)}
            >
              <div className="audio-jump">再生</div>
            </a>
          </td>
          {disableFlag === true ? null : (
            <td className={browser === 'IE' ? 'column-detail-ie' : 'column-detail'}>
              {convType === '2' ? (
                convTypeArrPc[i] === '2' ? (
                  voiceJa !== '' ? (
                    <ul>
                      <li>
                        <a
                          href=""
                          onClick={(e) => {
                            e.preventDefault();
                            this.changeConvTypePc(i);
                          }}
                          className="trans-link-open"
                        >
                          {CONV_STR}
                        </a>
                      </li>
                    </ul>
                  ) : null
                ) : voiceJa !== '' ? (
                  <div>
                    {voiceJa}
                    <a
                      href=""
                      onClick={(e) => {
                        e.preventDefault();
                        this.changeConvTypePc(i);
                      }}
                      className="trans-link-close-even"
                    >
                      {`[ 閉じる ]`}
                    </a>
                  </div>
                ) : null
              ) : convType === '1' ? (
                voiceJa !== '' ? (
                  <p>{voiceJa}</p>
                ) : null
              ) : null}
              {transType === '2' ? (
                transTypeArrPc[i] === '2' ? (
                  voiceEn !== '' ? (
                    <ul>
                      <li>
                        <a
                          href=""
                          onClick={(e) => {
                            e.preventDefault();
                            this.changeTransTypePc(i);
                          }}
                          className="trans-link-open"
                        >
                          {/* Googleによる翻訳... */}
                          {TRANS_STR}
                        </a>
                      </li>
                    </ul>
                  ) : null
                ) : voiceEn !== '' ? (
                  <div>
                    <p>{voiceEn}</p>
                    <img
                      src={googleIconTrans}
                      alt="translated by Google"
                      className="google-attribution"
                    />
                    <br />
                    <a
                      href=""
                      onClick={(e) => {
                        e.preventDefault();
                        this.changeTransTypePc(i);
                      }}
                      className="trans-link-close-even"
                    >
                      {`[ CLOSE ]`}
                    </a>
                  </div>
                ) : null
              ) : transType === '1' ? (
                voiceEn !== '' ? (
                  <>
                    <p>{voiceEn}</p>
                    <img
                      src={googleIconTrans}
                      alt="translated by Google"
                      className="google-attribution"
                    />
                  </>
                ) : null
              ) : null}
            </td>
          )}
        </tr>
      );
    }
    this.setState({ listMobile, listPc, convTypeArrPc, transTypeArrPc });
    return true;
  };

  toList = (e) => {
    e.preventDefault();
    window.removeEventListener('scroll', this.watchScrollPositionList, true);
    const { history } = this.props;
    const { lgCd, filename } = this.state;
    history.push({
      pathname: `/audioList/${lgCd}`,
      state: { path: filename },
    });
  };

  // 描画する範囲を示す関数のようなもの?
  render() {
    // const { listMobile, listPc, lgName } = this.state;
    const { listMobile, listPc, title, listPcHeader, browser } = this.state;
    // 状態をログに出す
    return (
      <>
        <div className="titleContent">
          {/* <h1 className="title">{lgName ? `${lgName}放送` : null}</h1> */}
          {/* オーディオ設定マスタからタイトルを取得するように修正　2020.9.30 */}
          <h1 className="title">{title ? title : null}</h1>
          {/* <a className="toOtherType-btn" onClick={(e) => this.toList(e)}>
            タイムライン
          </a> */}
        </div>
        &nbsp;
        <div className="listContainer">
          <div className="chatContainer">{listMobile}</div>
          {browser === 'IE' ? (
            <div className="boxList-pc-ie">
              <table className="table-list-ie">
                {listPcHeader[0]}
                <tbody id="tbody-ie" className="tbody-ie">
                  {listPc}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="boxList-pc">
              <table className="table-list">
                {listPcHeader[0]}
                <tbody>{listPc}</tbody>
              </table>
            </div>
          )}
        </div>
        <Footer />
      </>
    );
  }
}

List.propTypes = {
  location: PropTypes.shape({
    info: PropTypes.object,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    length: PropTypes.number.isRequired,
  }).isRequired,
};

export default withRouter(List);
